import { getActiveLoggingService } from "@/services/logger/logging-service";
import { InvalidLinkError } from "@/services/youtube-downloader/models";

const validQueryDomains = new Set([
  "youtube.com",
  "www.youtube.com",
  "m.youtube.com",
  "music.youtube.com",
  "gaming.youtube.com",
]);

const validPathDomains =
  /^https?:\/\/(youtu\.be\/|(www\.)?youtube\.com\/(embed|v|shorts|live)\/)/;
const idRegex = /^[a-zA-Z0-9-_]{11}$/;

const validateId = (id: string) => idRegex.test(id.trim());

export const getYouTubeVideoId = (link: string) => {
  const parsed = new URL(link.trim());
  let id = parsed.searchParams.get("v");

  if (validPathDomains.test(link.trim()) && !id) {
    const paths = parsed.pathname.split("/");
    id = parsed.host === "youtu.be" ? paths[1] : paths[2];
  } else if (parsed.pathname.startsWith("/shorts/")) {
    id = parsed.pathname.split("/shorts/")[1];
  } else if (parsed.hostname && !validQueryDomains.has(parsed.hostname)) {
    throw Error("Not a YouTube domain");
  }

  if (!id) {
    throw Error(`No video id found: "${link}"`);
  }

  id = id.substring(0, 11);
  if (!validateId(id)) {
    throw TypeError(
      `Video id (${id}) does not match expected ` +
        `format (${idRegex.toString()})`,
    );
  }
  return id;
};

export const isYouTubeUrl = (url: string): boolean => {
  try {
    if (validPathDomains.test(url.trim())) {
      return true;
    }

    const parsed = new URL(url.trim());
    return !!(parsed.hostname && validQueryDomains.has(parsed.hostname));
  } catch (e) {
    getActiveLoggingService().logError(
      new InvalidLinkError("Invalid link", url),
    );
    return false;
  }
};
